module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Karen Miller")]), _vm._v(" was born in Vancouver, Canada, and moved to Australia with her family when she was two. Apart from a three-year stint in the UK after graduating from university with a BA in communications, she's lived in and around Sydney ever since. Karen started writing stories while still in elementary school, where she fell in love with speculative fiction.  She's held a variety of interesting jobs but now writes full time.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EgDj8I/images/9780316133890.jpg?1733151293616",
      "alt": "This image is the cover for the book Blight of Mages, Kingmaker, Kingbreaker"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blight of Mages, Kingmaker, Kingbreaker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Hundreds of years before the great Mage War, a land lies, unknowing, on the edge of catastrophe. . .")]), _c('br'), _c('br'), _vm._v("Barl is young and impulsive, but she has a power within that calls to her. In her city, however, only those of noble blood and with the right connections learn the ways of the arcane. Barl is desperate to learn-but her eagerness to use her power leads her astray and she is banned from ever learning the mystic arts."), _c('br'), _c('br'), _vm._v("Morgan holds the key to her education. A member of the Council of Mages, he lives to maintain the status quo, preserve the mage bloodlines, and pursue his scholarly experiments. But Barl's power intrigues him-in spite of her low status."), _c('br'), _c('br'), _vm._v("Together, he realizes they can create extraordinary new incantations. Morgan's ambition and Barl's power make a potent combination. What she does not see is the darkness in him that won't be denied. "), _c('br'), _c('br'), _c('i', [_vm._v("A Blight of Mages ")]), _vm._v("is the new novel set in the world of Karen Miller's bestselling debut "), _c('i', [_vm._v("The Innocent Mage")]), _vm._v(".\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0